import React from 'react';
import { Divider } from 'semantic-ui-react';

import i18n from '@/settings/i18n';

export const Preview: React.FC = () => (
  <Divider horizontal={true}>{i18n.t('text.user.index.preview')}</Divider>
);
